import React from 'react';
import styles from '../styles/card.module.css';

const RouteCard = () => {
  return (
    <div className={styles['feature-card']}>
      <div className={styles['feature-content']}>
        <div className={styles['feature-content1']}>
          <h3>Smart Route Suggestion</h3>
          <p>Plan seamless journeys by combining trains and flights. All in one intelligent itinerary.</p>
        </div>
      </div>
      <div className={styles['feature-image']}>
        <img src="/background6.svg" alt="Feature Image"/>
      </div>
    </div>
  );
};

export default RouteCard;